<template>
  <!-- //会员到期提醒 -->
  <el-dialog
    :visible.sync="daoqiDialogVisible"
    :before-close="handleClose"
    width="1100px"
    top="5vh"
    center
  >
    <div class="daoqitishi">
      <div class="leftbgimg">
        <img src="static/img/sign-login.png" alt="" />
      </div>
      <div class="rightcontain">
        <div class="chooseinvoice" v-show="firststep">
          <p class="title">选择开票订单</p>
          <el-table
            ref="multipleTable"
            :data="orderList"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection"> </el-table-column>
            <el-table-column prop="orderName" label="訂單類型">
            </el-table-column>
            <el-table-column prop="orderNum" label="訂單編號">
            </el-table-column>
            <el-table-column
              prop="payTime"
              label="購買時間"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="realTotal"
              label="訂單金額"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
          <!-- <el-pagination
            layout="prev, pager, next"
            :total="orderListTotal"
            @current-change="orderListPageChange"
          >
          </el-pagination> -->
          <el-checkbox v-model="ruleForm.isMerge">合并开票</el-checkbox>
          <div class="buttonbox">
            <button class="relbutton" @click="nextstep()">下一步</button>
          </div>
        </div>
        <div class="invoiceinfo" v-show="secondstep">
          <p class="title">申请发票</p>

          <div class="invoicehead">
            <ul class="fontone">
              <li>发票类型</li>
              <li>发票抬头</li>
            </ul>
            <ul>
              <li class="fonttwo">电子普通发票</li>
              <li class="chooselei">
                <el-button
                  @click="ruleForm.isCompany = 'N'"
                  round
                  :type="ruleForm.isCompany == 'N' ? 'primary' : ''"
                  :class="ruleForm.isCompany == 'Y' ? 'noactive' : ''"
                  >个人</el-button
                ><el-button
                  @click="ruleForm.isCompany = 'Y'"
                  :type="ruleForm.isCompany == 'Y' ? 'primary' : ''"
                  :class="ruleForm.isCompany == 'N' ? 'noactive' : ''"
                  round
                  >单位</el-button
                >
              </li>
            </ul>
          </div>
          <el-form
            label-width="120px"
            label-position="left"
            class="demo-ruleForm"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
          >
            <div
              class="invoiceitem invoiceinput"
              v-if="ruleForm.isCompany == 'Y'"
            >
              <p class="fontone">单位信息</p>
              <el-form-item label="单位名称" prop="companyName">
                <el-input
                  v-model="ruleForm.companyName"
                  autocomplete
                ></el-input>
              </el-form-item>
              <el-form-item label="纳税人识别码" prop="companyNo">
                <el-input v-model="ruleForm.companyNo" autocomplete></el-input>
              </el-form-item>
              <p class="fontthree">
                <span class="redicon">*</span
                >为税务局规定必填项，请务必填写真实准确。
              </p>
            </div>
            <div class="invoiceitem invoiceinput">
              <p class="fontone">收票人信息</p>
              <el-form-item label="收票人手机" prop="contactMobile">
                <el-input
                  v-model="ruleForm.contactMobile"
                  autocomplete
                ></el-input>
              </el-form-item>
              <el-form-item label="收票人邮箱" prop="contactMail">
                <el-input
                  v-model="ruleForm.contactMail"
                  autocomplete
                ></el-input>
              </el-form-item>
              <p class="fontthree">
                <span class="redicon">*</span
                >为必填项，用于接收电子发票开具的短信通知和电子发票文件
              </p>
            </div>
            <div class="invoiceitem invoicebeizhu">
              <p class="fontone">发票内容</p>
              <el-form-item label="服务费" prop="remark">
                <el-input
                  placeholder="備注："
                  v-model="ruleForm.remark"
                ></el-input>
              </el-form-item>
              <p class="fontthree">
                本系统只能开具“服务费”，若需详情，请在备注栏填写具体内容。<br />
                发票金额为实际支付金额，不含虚拟资产，优惠等扣减金额。
              </p>
            </div>
            <div class="buttonbox">
              <button class="relbutton" @click="upstep()">上一步</button>
              <button class="relbutton" @click="submitForm('ruleForm')">
                提交
              </button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  orderList,
  addInvoice
} from "@/api/api"
export default {
  name: 'invoice',
  data () {
    var checkPhone = (rule, value, callback) => {//手机号码校验
      const phoneReg = /^[0-9]*$/
      if (!value) {
        return callback(new Error('电话号码不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (phoneReg.test(value)) {
            callback()
          } else {
            callback(new Error('电话号码格式不正确'))
          }
        }
      }, 100)
    }
    var checkEmail = (rule, value, callback) => {//邮箱校验
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱格式'))
        }
      }, 100)
    }
    return {
      userInfo: localStorage.userinfo ? JSON.parse(localStorage.userinfo) : {},
      showDiffDay: 0,
      orderListparam: {
        pageNum: 1,
        pageSize: 10000,
        status: 1,
        isInvoice: 'N'
      },
      orderList: [],
      orderListTotal: 0,
      orderListInvoice: [],//开发票订单
      firststep: true,//显示第一步
      secondstep: false,//第二步隐藏
      // isMerge: true,//是否合并
      ruleForm: {
        isMerge: true,   //是否合并开票 Y是 N否	
        isCompany: 'N',//是否公司Y 是 N否	
        contactMobile: '',//电话
        contactMail: '',//邮箱
        companyName: '',//公司名称	
        companyNo: '',//纳税人识别码	
        remark: '',//备注
      },
      rules: {
        companyName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        companyNo: [
          { required: true, message: '请输入纳税人识别码', trigger: 'change' }
        ],
        contactMobile: [
          { validator: checkPhone, trigger: 'blur' },
        ],
        contactMail: [
          { validator: checkEmail, trigger: 'blur' },
        ],

      }

    }
  },
  props: {
    daoqiDialogVisible: false,
  },
  mounted () {
    this.getOrderList()
  },
  methods: {
    handleClose (done) {
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done()
      //   })
      //   .catch(_ => { })
      // this.orderList = []
      // this.orderListInvoice = []
      // this.firststep = true,//显示第一步
      //   this.secondstep = false,//第二步隐藏
      //   this.ruleForm = {
      //     isMerge: true,
      //     isCompany: 'N',
      //     contactMobile: '',
      //     contactMail: '',
      //     companyName: '',
      //     companyNo: '',
      //     remark: '',
      //   },
      Object.assign(this.$data, this.$options.data())

      this.$emit('changeVisible', false)
      // done()
    }
    ,
    //选择开发票订单
    handleSelectionChange (val) {
      this.orderListInvoice = val
    },
    nextstep () {
      if (this.orderListInvoice.length > 0) {
        this.firststep = false
        this.secondstep = true
      } else {
        this.$message({
          message: '请选择要开发票订单',
          type: 'warning'
        })
      }

    },
    upstep () {
      this.firststep = true
      this.secondstep = false
    },
    // 开发票
    submitForm (formName) {
      // let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.ruleForm)
          let param = this.ruleForm
          param.isMerge = param.isMerge ? 'Y' : 'N'
          param.orderList = this.orderListInvoice
          console.log(param, 'param')
          addInvoice(param).then((res) => {

            if (res.code == 200) {

              this.$message({
                message: res.msg,
                type: 'success'
              })
              this.$emit('changeVisible', false)
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    getOrderList () {
      orderList(this.orderListparam).then((res) => {
        console.log(res, 'res')
        this.orderList = res.rows
        this.orderListTotal = res.total
      })
    },
    orderListPageChange (page) {
      this.orderListparam.pageNum = page
      this.getOrderList()
    },

  }

}
</script>

<style scoped lang="less">
/deep/.el-checkbox__input.is-checked + .el-checkbox__label,
/deep/.el-checkbox__label {
  color: #909399;
  font-weight: bold;
  line-height: 50px;
}
/deep/.el-dialog--center .el-dialog__body,
/deep/.el-dialog__header {
  padding: 0;
}
/deep/.el-dialog {
  border-radius: 10px;
}
/deep/.el-form-item__label {
  font-size: 16px;
  color: #4473d0;
}
/deep/.el-input__inner {
  height: 30px;
}
.redicon {
  color: #e60012;
}
.invoiceinput {
  /deep/.daoqitishi
    .rightcontain
    .invoiceinfo
    .invoiceitem[data-v-079e1be6]
    .el-input {
    border: none;
    border-bottom: 1px solid #ccc;
  }
  /deep/.el-input__inner {
    border: none;
    border-bottom: 1px solid #ccc;
  }
}
.invoicebeizhu {
  /deep/.el-input__inner {
    border-color: #4473d0;
  }
}

img {
  width: 100%;
  height: auto;
}
.daoqitishi {
  display: flex;
  justify-content: space-between;
  .leftbgimg {
    width: 340px;
    height: auto;
  }
  .rightcontain {
    flex: 1;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    padding: 0px 60px 36px 108px;
    font-family: "FangZheng-FanTi";
    .chooseinvoice {
      width: 100%;
    }
    .invoiceinfo {
      width: 100%;
      .invoicehead {
        margin-top: 30px;
        margin-bottom: 20px;
        ul {
          display: flex;
          li {
            flex: 1;
          }
        }
        .noactive {
          color: #4473d0;
          border-color: #4473d0;
        }
      }
      .invoiceitem {
        // /deep/.el-input {
        //   border: none;
        //   border-bottom: 1px solid #ccc;
        // }
        margin-bottom: 30px;
      }
      .chooselei {
        .el-button {
          width: 70px;
          height: 32px;
          text-align: center;
          line-height: 32px;
        }
        .el-button.is-round {
          padding: 0;
        }
      }
    }
    .title {
      color: #4473d0;
      font-size: 30px;
      text-align: right;
    }
    .fontone {
      font-size: 20px;
      // line-height: 38px;
    }
    .fonttwo {
      font-size: 16px;
      color: #4473d0;
    }
    .fontthree {
      font-size: 14px;
      margin-top: 4px;
      color: #aaaaaa;
    }
    .zitikai {
      font-family: KaiTi, "楷体", SimKai, "华文楷体", "STKaiti", "BiauKai",
        serif;
    }
    .buttonbox {
      text-align: center;
    }
    .relbutton {
      font-family: "FangZheng-FanTi";
      // margin-top: 80px;
      width: 176px;
      height: 32px;
      line-height: 32px;
      background: #409eff;
      border-radius: 24px;
      color: #fff;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/products/invoice/index.vue